import React, { useEffect, useMemo, useState } from 'react';
import UboInputs from './UboInputs';
import { Field, FieldArray, reduxForm, change } from 'redux-form';
import { withRouter, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import Accordion from '../../../Accordion';
import { FakeLoader, FormElems } from '../../..';
import { ERROR_UBO_ENABLE, UBO_ACCORDIAN_NAME, UBO_CREATE_FORM_NAME, UBO_SECTION_TYPE, uboDeclarationUrls, uboFields } from './constant';
import { MAKER_CHECKER_EVENT_TYPES_MLE, MOCK_API_VALUE, REQUIRED_MSG } from 'utils/constants/commonValues';
import { kycDocumentsUploadRes } from 'mockApiWiseReqRes';
import { POST } from 'utils/fetchWrappers';
import { toast } from 'react-toastify';
import { KYC_DOCUMENT_UPLOAD_SUCCESS } from 'mockApiWiseReqRes/mockApiWise.constants';
import { API_UPLOAD_KYC_DOCUMENT, API_VIEW_KYC_DOCUMENT } from 'utils/API/apiUrls';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from 'utils/constants/toastMessages';
import FileUploadField from 'components/FileUploadField';
import ImageViewModal from '../BusinessTab/ImageViewModal';
import { checkKycDocsEditable, defaultOption, defaultOptionDoc, fetchFieldValue, fetchOwnershipDetails, fetchUboActiveFlag, getDBUboCount, getTimeStampFromUrl, handleDeleteFile, onNext, setUboTabFormData, uboFormDefaultSetData, uboSubmitDataFormat, updateIsInvalidButton, verifyUpdateFormChange } from '../mle.utils';
import validate from './UboTab.validator';
import { DOCUMENT_CATEGORY, SUBMITTED_KEY, UPDATE_FORMTYPES } from '../mle.constants';
import { resetSuccessKey, saveAndContinueRequestV1, submitRequestCallMle } from 'containers/MerchantLegalEntity/redux/merchantLegalEntity.actions';
import { COMPLETE } from 'components/Timelinev1/timelinev1.contants';
import { createDeepCopyObj } from 'utils/helperMethods';
import { FORM_TOAST_MSGS } from '../BusinessTab/contants';

const UobTab = (props) => {
    const {
        isViewMode,
        isEditMode,
        actions,
        initialValues,
        handleSubmit,
        merchantLegalEntityData,
        nextPath,
        uboFormData,
        invalid,
        uniqueIdentifier,
        initialIntentId,
        checkerRemarks,
        isReEditFlow,
        createdAt,
        eventType
    } = props;
    const [docUrls, setDocUrls] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [poaOptions, setPoaOptions] = useState([]);
    const [activeCount, setActiveCount] = useState(fetchUboActiveFlag(uboFormData));
    const [invalidSubmit, setInvalidSubmit] = useState({});
    const [uboAdded, setUboAdded] = useState([])
    const [infoMsgs, setInfoMsgs] = useState({});
    const [intentId, setIntentId] = useState(initialIntentId || null);
    const [docTimeStamp, setDocTimeStamp] = useState(null);
    const [dbUBOCount, setDbUBOCount] = useState(0);
    const history = useHistory();
    const { location } = history;
    const locationArray = location.pathname.split('/');
    const screen = locationArray[1];

    useEffect(() => {
        setUboAdded([]);
    }, [Object.keys(uboFormData?.initial).length, Object.keys(uboFormData?.initial?.uboDetails || {}).length])
    
    
    useEffect(() => {
        // not in case of create mle all other cases to be handled
        if (isEditMode || isReEditFlow || Object.keys(uboFormData?.initial).length > 0) {
            const infoMsgs = verifyUpdateFormChange(uboFormData.initial, uboFormData.values);
            setInfoMsgs(infoMsgs);
            if (checkerRemarks) {
                const filteredEditedCategoryIdx = [
                    ...new Set(
                        Object.entries(checkerRemarks)?.filter(([key, value]) => !!infoMsgs[key] && value?.docCategory?.includes(DOCUMENT_CATEGORY.POA))?.map(([key, _]) => key?.split('.')[1])?.filter(item => !infoMsgs[`uboDetails.${item}.addressProofUrls`])
                    )
                ];
                
                actions.change(UBO_CREATE_FORM_NAME, "filteredEditedCategoryIdx", filteredEditedCategoryIdx);
            }
        }
    }, [uboFormData?.values?.uboDetails, Object.keys(uboFormData?.initial).length, uboFormData?.values?.uboDeclarationUrls]);
    
    const { formEvents, basicFormData } = merchantLegalEntityData;
   
    useEffect(() => {
        if (formEvents?.isFormSubmitted) {
            if (isReEditFlow)
                onNext(history, '/maker');
            if (isEditMode)
                onNext(history, '/mle-onboarding');
        } 

        return () => {
            if (isReEditFlow && formEvents?.isFormSubmitted) {        
                actions.resetSuccessKey({sectionType: UBO_SECTION_TYPE});
            } 
        }
    }, [formEvents?.isFormSubmitted]);

    const dbCountMethod = async (uniqueIdentifier) => {
        if (typeof uniqueIdentifier === 'string') {
            const payload = {
                entityCode: uniqueIdentifier.split('.')[0] // Assuming uniqueIdentifier is in the format "entityCode.timestamp"
            };
            const uboCount = await getDBUboCount(payload);
            setDbUBOCount(uboCount);
        }
    }
    useEffect(() => {
        if (eventType === MAKER_CHECKER_EVENT_TYPES_MLE.ownership_update) {
            // set active ubo Count
            dbCountMethod(uniqueIdentifier);
        }
        if (MOCK_API_VALUE)
            return;
        if (typeof(uniqueIdentifier) !== 'string' || !uniqueIdentifier) {
            if (nextPath) {
                onNext(history, nextPath);
            } else {
                onNext(history, '/mle-onboarding')
            }
        }
    }, []);

    useEffect(() => {
        if (basicFormData?.uboBasicDetails?.basicSectionData?.ProofOfAddresses)
            setPoaOptions([...defaultOptionDoc, ...basicFormData?.uboBasicDetails?.basicSectionData?.ProofOfAddresses] || [...defaultOption]);
    }, [basicFormData?.uboBasicDetails])


    useEffect(() => {
        if (formEvents?.[`${UBO_CREATE_FORM_NAME}status`] === COMPLETE && formEvents?.isFormSubmitted && !isEditMode && !isReEditFlow) {
            toast.success(SUCCESS_MESSAGES.MLE_SUCCESS)
            if (nextPath) {
                onNext(history, nextPath);
            } else {
                onNext(history, '/mle-onboarding')
            }
        
        } 
        return () => {
            if (formEvents?.[UBO_SECTION_TYPE] === SUBMITTED_KEY) {
                actions.resetSuccessKey({section_type: UBO_SECTION_TYPE});
            } 
        }

    }, [formEvents?.isFormSubmitted]);

    async function handleUploadKycImage(file, name, options) {
        const {
            isEditMode,
            entityId,
            fieldName
        } = options
        if (isUploading) return;
        setIsUploading(true);
        if (MOCK_API_VALUE) {
            toast.info('File upload successful');
            let resp = kycDocumentsUploadRes(KYC_DOCUMENT_UPLOAD_SUCCESS);
            
            setIsUploading(false);
            return resp?.data?.s3Url;
        }
        const formData = new FormData();
        formData.append('multipartFile', file);
        if (isEditMode) {
            formData.append('merchantId', entityId);
            formData.append('docType', fieldName);
            formData.append('entityType', 'MLE');
        }
        // formData.append(
        //     'uniqueIdentifier',
        //     `${mutateFormData.values.emailIds[0]}_${new Date().getTime()}`
        // );

        try {
            const response = await POST(
                API_UPLOAD_KYC_DOCUMENT,
                formData,
                {
                    'Content-Type': 'multipart/form-data;',
                },
                true
            );

            const { data } = response;

            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                actions.change(UBO_CREATE_FORM_NAME, name, [data.s3Path]);
                toast.info('File upload successful');
                setIsUploading(false);
                return data.s3Url;
            }
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        } catch (error) {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        }
        setIsUploading(false);
    }

    async function handleViewClick(docUrl) {
        const request = {
            s3Path: docUrl,
        };
        try {
            setIsUploading(true);
            const response = await POST(
                API_VIEW_KYC_DOCUMENT,
                request,
                {},
                true
            );
            const { data } = response;
            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                // if (data.s3Url.toLowerCase().includes('.pdf')) {
                //     window.open(data.s3Url);
                // } else {
                    setSelectedDocument(data.s3Url);
                    if (setDocTimeStamp) {
                        setDocTimeStamp(getTimeStampFromUrl(request.s3Path, createdAt));
                    }
                // }
            } else {
                toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
            }
            setIsUploading(false);
        } catch (error) {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
            setIsUploading(false);
        }
    }

    function handleSubmitForm(formData) {
        
        
        // formData.section = UBO_SECTION_TYPE;
        try {
            const enableCount =  activeCount.filter(item => item);
            if (enableCount?.length <= 0) {
                toast.error(ERROR_UBO_ENABLE);
                return;
            }

            if (isEditMode || isReEditFlow) {
                handleUpdateClick(formData);
                return;
            }
            let updatedPayload = uboSubmitDataFormat(createDeepCopyObj(formData), uniqueIdentifier, intentId);

            if (!updatedPayload) {
                return;
            }
            
            actions.saveAndContinueRequestV1(updatedPayload);
        } catch(e) {
            console.log("error while submitting the form");
        }
    }

    const handleSaveClick = (e) => {
        // create functionality -> Continue and submit currently both are together
        e.preventDefault()
        
        try {
            let payload = {};
            uboFormDefaultSetData(payload, uniqueIdentifier);
            
            actions.submitRequestCallMle(payload);
            
        } catch(e) {
            console.log("handleSaveClick e", e);
        }
    }

    const handleUpdateClick = (formData) => {
        // create functionality -> Continue and submit currently both are together
        
        
        try {
            if (invalid){
                return;
            }
            let uniqueIdentifierWithTimeStamp = (isReEditFlow) ? uniqueIdentifier : `${uniqueIdentifier}.${Date.now()}`
            let payload = uboSubmitDataFormat(createDeepCopyObj(formData), uniqueIdentifierWithTimeStamp, intentId);
            if (!payload) {
                return;
            }
            payload.formType = UPDATE_FORMTYPES.ubo;
            if (isReEditFlow) {
                payload.entityId = uniqueIdentifier.split('.')[0];
            } else {
                payload.entityId = uniqueIdentifier;
            }
            payload.isEditMode = !!isEditMode;
            
            payload.isReEditFlow = !!isReEditFlow;
            
            
            
            actions.submitRequestCallMle(payload);
            
        } catch(e) {
            console.log("handleSaveClick e", e);
        }
    }

    const uboDataNotUpdated = useMemo(() => {
        return Object.keys(infoMsgs || {}).length === 0 && uboAdded?.length === 0
    }, [Object.keys(infoMsgs || {})?.length, 
        infoMsgs, Object.values(infoMsgs || {}),  
        Object.keys(infoMsgs || {}), 
        Object.values(infoMsgs || {})?.length, 
        uboAdded, uboAdded?.length, Object.values(uboFormData?.initial).length, JSON.stringify(Object.values(uboFormData?.initial))]);
    
    const initialsLength = useMemo(() => {
        return Object.keys(uboFormData?.initial)?.length;
    }, [Object.keys(uboFormData?.initial)?.length]);
    
    
    return (
        <div className="merchant-legal-entity-onboarding-wrapper">
            <ImageViewModal
                selectedDocument={selectedDocument}
                setSelectedDocument={setSelectedDocument}
                timeStamp={docTimeStamp}
            />
            {isUploading ? <FakeLoader withMask /> : null}
            <h2 className="title">Ownership Details</h2>
            <form
                className="mle-onboarding-form"
                onSubmit={handleSubmit(handleSubmitForm)}
            >
                <ul className="form-list">
                    <li className="form-section">
                        <FileUploadField
                            itemInfo={uboDeclarationUrls}
                            handleUploadImageAndGetUrl={
                                (file) => {
                                    return handleUploadKycImage(
                                        file, 
                                        uboDeclarationUrls.reqname,
                                        {
                                            isEditMode: isEditMode || isReEditFlow,
                                            entityId: uniqueIdentifier,
                                            fieldName: uboDeclarationUrls.reqname
                                        }
                                    )
                                }
                            }
                            handleViewClick={handleViewClick}
                            docUrls={docUrls}
                            setDocUrls={setDocUrls}
                            actions={actions}
                            handleDeleteFile={() => {handleDeleteFile(uboDeclarationUrls.reqname, UBO_CREATE_FORM_NAME, actions)}}
                            checkerRemarks={checkerRemarks}
                            values = {uboFormData?.values}
                            required={true}
                            isViewMode={isViewMode}
                            isEditMode={isEditMode}
                            isEditable={true}    
                            infoMsgs={infoMsgs}  
                            isReEditFlow={isReEditFlow}
                            showDate={true}
                            defaultDate={createdAt}       
                            initialValue={fetchFieldValue(uboFormData?.initial, uboDeclarationUrls.reqname)}  
                        />
                    </li>
                    <li>
                      <FieldArray
                          name={UBO_ACCORDIAN_NAME}
                          component={UboInputs}
                          change={change}
                          isEditMode={isEditMode}
                          isViewMode={isViewMode}
                          actions={actions}
                          initialData={initialValues}
                          setIsUploading={setIsUploading}
                          setSelectedDocument={setSelectedDocument}
                          poaOptions={poaOptions}
                          activeCount={activeCount}
                          setActiveCount={setActiveCount}
                          setInvalidSubmit={setInvalidSubmit}
                          uboFormData={uboFormData}
                          intentId={intentId}
                          checkerRemarks={checkerRemarks}
                          setUboAdded={setUboAdded}
                          infoMsgs={infoMsgs}
                          uboAdded={uboAdded}
                          entityId={uniqueIdentifier}
                          isReEditFlow={isReEditFlow}
                          setIntentId={setIntentId}
                          createdAt={createdAt}
                          setDocTimeStamp={setDocTimeStamp}
                          eventType={eventType}
                          dbUBOCount={dbUBOCount}
                      />
                    </li>
                </ul>
                <div className="form-section action">
                    {
                    (isEditMode || isReEditFlow) && (
                        <FormElems.Button
                            id="next-btn"
                            buttonType="primary"
                            type="button"
                            text="Update"
                            customClass={(invalid)?'disabled-mle-button':''}
                            handleClick={() => {
                                if (uboAdded.length > 0 && !JSON.stringify(infoMsgs).includes(uboDeclarationUrls.reqname)) {
                                    toast.error("Action needed: Upload the UBO Declaration document.");
                                    return;
                                }
                                handleSubmit(handleSubmitForm)();
                            }}
                            // check when valid that verify button is clicked
                            isDisable={
                                ((isEditMode || isReEditFlow) && Object.keys(infoMsgs).length === 0 && uboAdded?.length === 0) || 
                                (!invalid && Object.values(invalidSubmit).filter(item => item).length > 0)
                            }
                        />
                    )}
                    {
                        (!isEditMode && !isReEditFlow) && (
                            <>
                                <FormElems.Button
                                    id="next-btn"
                                    buttonType="primary"
                                    type="button"
                                    text="Save"
                                    customClass={(invalid)?'disabled-mle-button':''}
                                    // check when valid that verify button is clicked
                                    isDisable={isViewMode || 
                                        (!invalid && Object.values(invalidSubmit).filter(item => item).length > 0) ||
                                        (uboDataNotUpdated && initialsLength > 0)}
                                    handleClick={() => {           
                                                                    
                                        if (uboFormData?.syncErrors && JSON.stringify(uboFormData?.syncErrors).includes(REQUIRED_MSG)) {
                                            toast.error(FORM_TOAST_MSGS.REQUIRED);
                                            // return;
                                        }
                                        handleSubmit(handleSubmitForm)()
                                    }}
                                />
                                {(screen !== 'maker') && (
                                    <FormElems.Button
                                        id="save-btn"
                                        buttonType="primary"
                                        type="button"
                                        text="Submit"
                                        handleClick={handleSaveClick}
                                        isDisable={formEvents?.[`${UBO_CREATE_FORM_NAME}status`] !== COMPLETE ||
                                        isViewMode || invalid || (!invalid && Object.values(invalidSubmit).filter(item => item).length > 0) ||
                                        (!uboDataNotUpdated && initialsLength > 0)}
                                    />
                                )}
                        </>
                        )
                    }
                    
                </div>
            </form>
        </div>
    );
};

UobTab.propTypes = {
    nextPath: PropTypes.string,
  isViewMode: PropTypes.bool,
  isEditMode: PropTypes.bool,
  actions: PropTypes.object,
  initialValues: PropTypes.object,
  handleSubmit: PropTypes.func
};

const mapStateToProps = ({
  auth,
  form,
  merchantLegalEntityData,
  nextPath
}) => ({
  auth,
  uboFormData: form[UBO_CREATE_FORM_NAME],
  merchantLegalEntityData,
  nextPath
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    change,
    saveAndContinueRequestV1,
    resetSuccessKey,
    submitRequestCallMle
  }, dispatch)
})

export default withRouter(
    compose(
        reduxForm({
            form: UBO_CREATE_FORM_NAME,
            validate,
            initialValues: {},
            enableReinitialize: true
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(UobTab)
);
